import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "customer-forecast-difference" }
const _hoisted_2 = { class: "customer-forecast-difference__top-area top-area" }
const _hoisted_3 = { class: "top-area__button-area button-area" }
const _hoisted_4 = { class: "download-button__container" }
const _hoisted_5 = { class: "download-button__text" }
const _hoisted_6 = { class: "customer-forecast-difference__filter-content filter-content" }
const _hoisted_7 = { class: "customer-forecast-difference__table-area table-area" }
const _hoisted_8 = { class: "table-area__top-accessory" }
const _hoisted_9 = { class: "table-area__select-month-area select-month-area" }
const _hoisted_10 = { class: "select-month-area__title" }
const _hoisted_11 = {
  key: 0,
  class: "table-area__business-table table-area__business-table--zero-match"
}

import { storeToRefs } from 'pinia';
import ControlCustomerPageTab from '../components/ControlCustomerPageTab.vue';
import { CUSTOMER_TAB_ROUTER_INFO } from '../constants';
import { computed, onBeforeMount } from 'vue';
import NewBaseTableContent from '@/corePagesModule/BaseTableContent/NewBaseTableContent.vue';
import SvgLoader from '@/utils/SvgLoader.vue';
import { i18n } from '@/i18n';
import TextButton from '@/components/input/Btn/TextButton.vue';
import FilterModalButton from '@/corePagesModule/filterModal/FilterModalButton.vue';
import MonthPicker from '@/corePagesModule/components/MonthPicker.vue';
import Pagination from '@/corePagesModule/components/Pagination.vue';
import SelectInput from '@/corePagesModule/SelectInput';
import { CustomerForecastRepository } from '@/coreInfrastructureModule/Repositories/CustomerForecastRepository';
import { useCustomerForecastDiffLastMonthStore } from './useCustomerForecastDiffLastMonthStore';


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerForecastDiffLastMonth',
  setup(__props) {

const t = i18n.t;
const store = useCustomerForecastDiffLastMonthStore();
const { state } = storeToRefs(store);
const locale = computed(() => i18n.locale);

const customerForecastRepository = new CustomerForecastRepository();

onBeforeMount(() => {
  store.init(customerForecastRepository);
});

const monthsOptionsDisplayForecast = computed(() => {
  return store.monthsOptionsDisplayForecastNumber.map((monthsOption) => monthsOption + t('unitMonth'));
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ControlCustomerPageTab, {
        class: "top-area__tab-bar",
        "tab-info-object": [..._unref(CUSTOMER_TAB_ROUTER_INFO)]
      }, null, 8, ["tab-info-object"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(TextButton, {
          class: "button-area__download-button download-button button-area__button button-area__button--white",
          disabled: true,
          onClick: () => {}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)('ダウンロード')), 1),
              _createVNode(SvgLoader, {
                class: "download-button__icon",
                name: "fatArrowDown"
              })
            ])
          ], undefined, true),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(FilterModalButton, {
        "filter-modal-type": 'customerForecast',
        "modal-state": _unref(state).detailFilterModalState,
        "select-input-index": 1,
        "filter-items": _unref(store).getFilterItemsValue().value,
        onApply: _cache[0] || (_cache[0] = (filteredContents) => _unref(store).onAppliedDetailFilter(_unref(customerForecastRepository), filteredContents))
      }, null, 8, ["modal-state", "filter-items"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(t)('forecastForReceipt_searchReceiveDate')), 1),
          _createVNode(MonthPicker, {
            class: "select-month-area__calendar",
            "model-value": _unref(state).receivedForecastYearMonth,
            locale: locale.value,
            "prop-format": _unref(t)('MonthPickerFormat'),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_unref(store).onSelectedReceiveMonth($event, _unref(customerForecastRepository))))
          }, null, 8, ["model-value", "locale", "prop-format"])
        ]),
        (_unref(state).tableContents.pagingOptions)
          ? (_openBlock(), _createBlock(Pagination, {
              key: 0,
              "paging-options": _unref(state).tableContents.pagingOptions,
              "is-loading": _unref(state).tableContents.loadingState.status.type === 'loading',
              class: "table-area__pagination",
              onOnChangePage: _cache[2] || (_cache[2] = ($event: any) => (_unref(store).onChangePaging($event, _unref(customerForecastRepository))))
            }, null, 8, ["paging-options", "is-loading"]))
          : _createCommentVNode("", true),
        _createVNode(_unref(SelectInput), {
          class: "table-area__forecast-length-select",
          index: 21,
          "model-value": _unref(t)('displayMonthsOfData', { month: _unref(state).displayForecastsMonth }),
          placeholder: '',
          label: '',
          "filter-type": 'DISPLAY_MONTH',
          "prop-options": monthsOptionsDisplayForecast.value,
          "is-open-prop": _unref(state).openedSelectInputType === 'DISPLAY_MONTH',
          "use-teleport": "",
          "onClick:selectInput": _cache[3] || (_cache[3] = () => (_unref(state).openedSelectInputType = 'DISPLAY_MONTH')),
          "onUpdate:valueWithIndex": _cache[4] || (_cache[4] = (_, index) => _unref(store).onSelectedDisplayForecastsMonth(index, _unref(customerForecastRepository)))
        }, null, 8, ["model-value", "prop-options", "is-open-prop"])
      ]),
      (_unref(state).tableContents.loadingState.status.type === 'zeroMatch')
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(t)('forecastForReceipt_placeholderForZeroMatch')), 1))
        : (_openBlock(), _createBlock(NewBaseTableContent, {
            key: _unref(state).tableContents.renderingKey,
            class: "table-area__business-table table-area__business-table--success",
            "prop-table-content-properties": _unref(state).tableContents.tableHeaders,
            "prop-display-objects": _unref(store).tableContentItems,
            "prop-loading-status": _unref(state).tableContents.loadingState,
            "prop-table-type": 'customerForecastDiffLastMonth',
            onChecked: _cache[5] || (_cache[5] = (checkedDisplayIds) => _unref(store).onCheckedDisplayIds(checkedDisplayIds)),
            onOnClickSort: _cache[6] || (_cache[6] = (sortKey) => _unref(store).sortTableContentItems(sortKey, _unref(customerForecastRepository))),
            onOnClickTransitionTimeline: _cache[7] || (_cache[7] = (selectedDisplayId) => _unref(store).onClickTransitionTimelineButton(selectedDisplayId))
          }, null, 8, ["prop-table-content-properties", "prop-display-objects", "prop-loading-status"]))
    ])
  ]))
}
}

})